module.exports = __webpack_public_path__ + "img/menu-icon.d18c9e10.svg";